import { addToLocalStorage } from '..';
import * as uuid from 'uuid';

export const createSession = () => {
  const session = {
    id: uuid.v4(),
    start: new Date().getTime(),
  };
  addToLocalStorage({ key: 'sessionId', value: JSON.stringify(session) });
  return session;
};

export const getSession = (): { id: string; start: number } | null => {
  const session = localStorage.getItem('sessionId');
  return JSON.parse(session!) || null;
};
